import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalContext } from '../services/global-context.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard implements CanActivate {
  private globalContext = inject(GlobalContext);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentState = this?.globalContext?.store();

    if (currentState?.classification !== 'Company') {
      this.router?.navigate(['/error'], {
        state: { error: { message: 'Only Company users are authorized to access MU3.' } },
      });
      return false;
    }

    const permissions = currentState?.permissions || [];
    if (
      !permissions.includes('MU3') &&
      !permissions.includes('MU3Submitter') &&
      !permissions.includes('Administrator')
    ) {
      this.router?.navigate(['/error'], {
        state: { error: { message: 'You do not have the required MU3 permission to access this filing.' } },
      });
      return false;
    }

    return true;
  }
}
